export default __webpack_public_path__ + "static/editorialnew-regular-d61dd64323a4499270c6b8bc90e61603.woff2";